const Skills = () => {
  return (
    <div className=" d-flex align-items-center justify-content-center mt-md-5">
      <article className="skillDiv row container mt-md-5  m-auto col-8 gap-2 d-flex align-items-center justify-content-center">
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/html.png" alt="html" />
          </div>
          <div className="title text-light fs-5">HTML</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/css.png" alt="css" />
          </div>
          <div className="title text-light fs-5">CSS</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/js.png" alt="js" />
          </div>
          <div className="title text-light fs-5">JS</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/react.png" alt="react" />
          </div>
          <div className="title text-light fs-5">REACT</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/bootstrap5.png" alt="bootstrap" />
          </div>
          <div className="title text-light fs-5">BOOTSTRAP</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/materialui.png" alt="mui" />
          </div>
          <div className="title text-light fs-5">MUI</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/sass.png" alt="sass" />
          </div>
          <div className="title text-light fs-5">SASS</div>
        </div>
        <div className="skill git d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/git.png" alt="git" />
          </div>
          <div className="title text-light fs-5">GIT</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/github.png" alt="github" />
          </div>
          <div className="title text-light fs-5">GITHUB</div>
        </div>
        <div className="skill d-flex flex-column col-sm-6 col-md-4 col-lg-3 align-items-center justify-content-between py-1">
          <div className="image d-flex align-items-center justify-content-center">
            {" "}
            <img src="images/jira.png" alt="jira" />
          </div>
          <div className="title text-light fs-5">JIRA</div>
        </div>
      </article>
    </div>
  );
};

export default Skills;
